<aside class="painel-sidebar">
    <ul>
        <li *ngFor="let item of keys">
            <a [routerLink]="[menu[item].link]" [routerLinkActive]="['current']">
                <i class="material-icons">{{menu[item].icon}}</i>
                <span translate>{{item}}</span>
            </a>
        </li>
    </ul>
</aside>